import React, { useState } from "react";
import Modal from "../../../../components/Reusable/Modal";
import { useAppDispatch } from "../../../../hooks/hooks";
import {
  deleteDataPlan,
  fetchDataPlans,
} from "../../../../features/auth/store/dataPlanSlice";
import { toast } from "react-toastify";
import { DeleteModalProps } from "../types";

export const DeleteDataModal: React.FC<DeleteModalProps> = ({
  id: dataPlanId,
  isOpen,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    if (dataPlanId === null) return;
    setIsSubmitting(true);
    try {
      await dispatch(deleteDataPlan(dataPlanId)).unwrap();
      toast.success("Data Plan deleted successfully! 🚀");
      onClose();
      dispatch(fetchDataPlans({}));
    } catch (err: any) {
      toast.error(err?.message || "Failed to delete plan");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-xl font-bold mb-4">Delete Data Plan</h2>
      <div className="p-4">
        <p>Are you sure you want to delete this data Plan?</p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
